export default __webpack_public_path__ + "static/media/possible-world-text.9065ca98.svg";